import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly apiOrigin = new URL(environment.serverUrl).origin;

  constructor() { }

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    const authToken = localStorage.getItem('auth-token');
    const authRequest = request.clone({
      setHeaders: {
        Authorization: `Bearer ${authToken}`
      },
      // withCredentials so the HttpOnly auth cookie (set by the API on login) rides along;
      // Bearer stays primary during the localStorage->cookie compatibility period.
      withCredentials: request.url.startsWith(this.apiOrigin) ? true : request.withCredentials,
    });
    return next.handle(authRequest);
  }
}
